import React, { useState, useEffect } from "react";
import DatePicker from "../datePicker";
import Title from "../FormElements/Title";
import { FormContext } from "react-hook-form";
import { InputField } from "../FormElements/InputField";
import { InputSelect } from "../FormElements/InputSelect";
import FormTitle from "../FormElements/FormTitle";
import Button from "../FormElements/Button";
import ErrorCustom from "../errorCustom";
import BoxNumber from "../boxNumber";
import { validateOnlyDecimalNumbers } from "../../Utils/validators";
import { getObjSendFormValue, formatCurrencySummation } from "../../Utils/rveoUtils";

interface StepFinancialDataProps {
  methodFinancial: any;
  handleSubmitFinancial: any;
  nextActiveStep: (id: number) => void;
  setObjSendForm: (data: any) => void;
  objSendForm: any;
  setValueFinancial: any;
  registerFinancial: any;
  errors: any;
  formatCurrency: (value: number) => string;
  capitalPension: any;
  dateDevOrig: any;
  dateDeven: any;
}

const StepFinancialData: React.FC<StepFinancialDataProps> = ({
  methodFinancial,
  handleSubmitFinancial,
  nextActiveStep,
  setObjSendForm,
  objSendForm,
  setValueFinancial,
  registerFinancial,
  errors,
  formatCurrency,
  capitalPension,
  dateDevOrig,
  dateDeven,
}) => {
  const [localDateDeven, setLocalDateDeven] = useState<any>(dateDeven || null);
  const [localDateDevOrig, setLocalDateDevOrig] = useState<any>(
    dateDevOrig || null
  );

  const capitalPensionNumeric = objSendForm && objSendForm.capitalPension
    ? formatCurrencySummation(objSendForm.capitalPension)
    : formatCurrencySummation(capitalPension);
  const isMinimumPensionCapital = capitalPensionNumeric >= 30000;

  useEffect(() => {
    if (dateDeven) {
      setLocalDateDeven(dateDeven);
    }
    if (dateDevOrig) {
      setLocalDateDevOrig(dateDevOrig);
    }
  }, [dateDeven, dateDevOrig]);
  
  return (
    <FormContext {...methodFinancial}>
      <form
        style={{
          minHeight: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
        onSubmit={handleSubmitFinancial((value: any) => {
          nextActiveStep(2);
          setObjSendForm({ ...objSendForm, ...value });
        })}
      >
        <div>
          <FormTitle title="Ingresa los datos financieros del contratante" />
          <Title title="CIC" />
          <BoxNumber
            setValue={setValueFinancial}
            register={registerFinancial}
            initCounter={getObjSendFormValue(objSendForm, "cic", 0)}
            nameVal="cic"
            verifyMoney={"PEN"}
            incrementValue={1000}
            disabled={false}
            validatorInput={validateOnlyDecimalNumbers}
            base={0}
            financial={true}
          />
          <ErrorCustom errors={errors} name="cic" />
          <Title title="Bono Reconocimiento" />
          <BoxNumber
            setValue={setValueFinancial}
            register={registerFinancial}
            initCounter={getObjSendFormValue(objSendForm, "recogBonus", 0)}
            nameVal="recogBonus"
            verifyMoney={"PEN"}
            incrementValue={1000}
            disabled={false}
            validatorInput={validateOnlyDecimalNumbers}
            base={0}
            financial={true}
          />
          <ErrorCustom errors={errors} name="recogBonus" />
          <Title title="Aporte Adicional" />
          <BoxNumber
            setValue={setValueFinancial}
            register={registerFinancial}
            initCounter={getObjSendFormValue(objSendForm, "addContribution", 0)}
            nameVal="addContribution"
            verifyMoney={"PEN"}
            incrementValue={1000}
            disabled={false}
            validatorInput={validateOnlyDecimalNumbers}
            base={0}
            financial={true}
          />
          <ErrorCustom errors={errors} name="addContribution" />
          <Title title="Capital Pensión" />
          <InputField
            disabled={true}
            name="capitalPension"
            register={registerFinancial}
            defaultValue={formatCurrency(capitalPensionNumeric)}
          />
          <Title title="Fecha Devengue" />
          <DatePicker
            name="dateDeven"
            register={registerFinancial}
            onChange={(date) => setLocalDateDeven(date)}
            defaultValue={
              objSendForm && objSendForm.dateDeven ? objSendForm.dateDeven : ""
            }
          />
          <Title title="Número Mensualidades" />
          <InputSelect
            options={[
              {
                value: "12 Mensualidades",
                name: "12 Mensualidades",
                id: 1,
              },
              {
                value: "14 Mensualidades",
                name: "14 Mensualidades",
                id: 2,
              },
            ]}
            placeHolder="Mensualidades"
            defaultValue={"12 Mensualidades"}
            register={registerFinancial}
            name="monthlyPayments"
            id="monthlyPayments"
            disabled
          />
          <Title title="Fecha Dev. Original" />
          <DatePicker
            name="dateDevOrig"
            register={registerFinancial}
            onChange={(date) => setLocalDateDevOrig(date)}
            defaultValue={
              objSendForm && objSendForm.dateDevOrig
                ? objSendForm.dateDevOrig
                : ""
            }
          />
        </div>
        <div className="button__container">
          <Button type="submit" disabled={!localDateDevOrig || !localDateDeven || !isMinimumPensionCapital}>
            Continuar
          </Button>
        </div>
      </form>
    </FormContext>
  );
};

export default StepFinancialData;
